<app-modal-template
  [title]="'Change slides access' | translate"
  [hasCloseButton]="true"
  [size]="PencilModalSizeEnum.MEDIUM"
  (closeButtonClicked)="onCancel()"
>
  <div content-description class="slides-access-dialog__content">
    <svg-icon
      class="slides-access-dialog__mockup"
      [icon]="'make_public'"
      [width]="352"
      [height]="233"
    ></svg-icon>
    <p class="slides-access-dialog__instruction">
      {{ 'To present slides to everyone, set access to"' | translate }}{{ ' '
      }}<strong> {{ 'Anyone with the link.' | translate }}</strong
      >{{ ' ' }}
      {{ '"Alternatively, you can log in to access your slides.' | translate }}
    </p>
    <p *ngIf="(accessState$ | async) === false" class="slides-access-dialog__error">
      {{
        'Slides access is restricted. Please make sure the presentation is set to public.'
          | translate
      }}
    </p>
  </div>
  <div content-actions>
    <app-pencil-button
      *ngIf="(accessState$ | async) !== false"
      [theme]="PencilButtonThemeEnum.PRIMARY"
      icon="check"
      [iconConfig]="{ type: IconTypes.matIcon }"
      [label]="'Slides are public' | translate"
      [disabled]="(isChecking$ | async) === true"
      [showSpinner]="(isChecking$ | async) ?? false"
      (clickEvent)="onSlidesPublic()"
    >
    </app-pencil-button>
    <app-pencil-button
      *ngIf="(accessState$ | async) === false"
      [theme]="PencilButtonThemeEnum.DANGER"
      icon="refresh"
      [iconConfig]="{ type: IconTypes.matIcon }"
      [label]="'Check again' | translate"
      [disabled]="(isChecking$ | async) === true"
      [showSpinner]="(isChecking$ | async) ?? false"
      (clickEvent)="onCheckAgain()"
    >
    </app-pencil-button>
    <app-pencil-button
      [theme]="PencilButtonThemeEnum.SECONDARY_OUTLINE"
      icon="login"
      [iconConfig]="{ type: IconTypes.matIcon }"
      [label]="'Log in instead' | translate"
      (clickEvent)="onLogInInstead()"
    >
    </app-pencil-button>
  </div>
</app-modal-template>
